module.exports = __webpack_public_path__ + "img/go2.ec099213.png";